export enum SkillKeys {
  MORE_FUN = 'MORE_FUN',
  MOST_FUN_MORE_MINOR_ACCIDENTS = 'MOST_FUN_MORE_MINOR_ACCIDENTS',
  LEAST_MAJOR_ACCIDENTS = 'LEAST_MAJOR_ACCIDENTS',
  LEAST_MINOR_ACCIDENTS = 'LEAST_MINOR_ACCIDENTS',
  LESS_ACCIDENTS = 'LESS_ACCIDENTS'
}
